import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;

  height: 245px;
  width: 303px;
  border-radius: 10px;
  padding: 0 30px;
  box-sizing: border-box;
  background-color: #f9f9f9;
  padding: 24px 30px 16px;

  @media screen and (max-width: 800px) {
    width: 327px;
  }

  &:hover {
    box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  }
`;

export const WidgetHead = styled.div`
    flex-shrink: 0;
`;

export const WidgetTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 28px;
  color: #222222;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WidgetContent = styled.label`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 173%;
  letter-spacing: 0px;
  text-align: center;
  color: #313c4b;
  cursor:pointer;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;